import { Cloud, Key, Lock, Wrench } from "lucide-react";
import { Suspense } from "react";
import { MetricWidgetSkeleton } from "../skeletons/metric-widget-skeleton";
import { OAuthProvidersMetric } from "./metrics/oauth-providers-metric";
import { SecretsMetric } from "./metrics/secrets-metric";
import { ServersMetric } from "./metrics/servers-metric";
import { ToolsMetric } from "./metrics/tools-metric";

export function MetricsWidget() {
  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      <Suspense fallback={<MetricWidgetSkeleton icon={Wrench} title="Tools" />}>
        <ToolsMetric />
      </Suspense>
      <Suspense
        fallback={<MetricWidgetSkeleton icon={Cloud} title="Servers" />}
      >
        <ServersMetric />
      </Suspense>
      <Suspense
        fallback={<MetricWidgetSkeleton icon={Lock} title="OAuth Apps" />}
      >
        <OAuthProvidersMetric />
      </Suspense>
      <Suspense fallback={<MetricWidgetSkeleton icon={Key} title="Secrets" />}>
        <SecretsMetric />
      </Suspense>
    </div>
  );
}
